export enum BundleCodeEnum {
    LIBI = 'LIBI',
    SeuilAtteint = 'SeuilAtteint',
    horsForfait = 'horsForfait',
    EPUISE = 'EPUISE',
    PTF = 'PTF',
    SOLDE = 'SOLDE',
}
